<div>
	<p-table styleClass="gridStyle"  [columns]="cols" [value]="dataHistory"
             [resizableColumns]="true" selectionMode="single"
             [scrollHeight]="_scrollHeight" [scrollable]="true"
             [loading]="loading" dataKey="id">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" pResizableColumn [pSortableColumn]="col.field"
                style="font-size: smaller !important" [style.flexBasis]="col.width">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
		        <tr [pSelectableRow]="rowData">
		            <td *ngFor="let col of columns" [style.flexBasis]="col.width">
		                {{(col.labelFunction === undefined || col.labelFunction === null) ? rowData[col.field] : col['labelFunction'](rowData, col)}}
		                <!--{{appSettings.formatJsonDateCommon(rowData[col.field],col.field)}}-->
		            </td>
		        </tr>
		</ng-template>
</p-table>
</div>




